import type { CheckoutReturnStatus } from '~/pages/backoffice/admin/billing/use-checkout-return'
import { CircleCheck, Clock, Info, LoaderCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const ICONS = { pending: LoaderCircle, confirmed: CircleCheck, slow: Clock, canceled: Info } as const

/** Ce que l'admin lit en revenant de Stripe Checkout (#352). */
function CheckoutReturnNotice({ status }: { status: CheckoutReturnStatus }) {
  const { t } = useTranslation()
  const Icon = ICONS[status]

  return (
    <div role="status" className="flex items-start gap-3 rounded-lg border bg-card p-4">
      <Icon className={`mt-0.5 size-5 shrink-0 ${status === 'pending' ? 'animate-spin motion-reduce:animate-none' : ''}`} aria-hidden />
      <div className="space-y-1">
        <p className="font-medium">{t(`billing.checkout.${status}.title`)}</p>
        <p className="text-sm text-muted-foreground">{t(`billing.checkout.${status}.body`)}</p>
      </div>
    </div>
  )
}

export default CheckoutReturnNotice
